/**
 * JBM Performance - Ex VAT Price Updater
 * Updates the ex-VAT and inc-VAT price display whenever a product variant is changed.
 */
(function () {
  'use strict';

  // UK standard VAT rate: 20%
  var VAT_RATE = 0.20; 

  function formatMoney(pence) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.moneyFormat) {
      return theme.Currency.formatMoney(pence, theme.moneyFormat);
    }
    return '£' + (pence / 100).toFixed(2);
  }

  function calcExVat(incVatPence) {
    // ex_vat = inc_vat / 1.2
    return Math.round(incVatPence * 100 / 120);
  }

  function updateVatDisplay(container, variant) {
    if (!variant) return;

    var incVatPence = variant.price;
    var exVatPence  = calcExVat(incVatPence);

    var incVatEls = container.querySelectorAll('[data-inc-vat-price]');
    var exVatEls  = container.querySelectorAll('[data-ex-vat-price]');

    incVatEls.forEach(function (el) {
      el.innerHTML = formatMoney(incVatPence);
    });

    exVatEls.forEach(function (el) {
      el.innerHTML = formatMoney(exVatPence);
    });
  }

  function init() {
    var productSections = document.querySelectorAll('[data-section-type="product"]');

    productSections.forEach(function (section) {
      section.addEventListener('variantPriceChange', function (e) {
        var variant = e.detail ? e.detail.variant : (e.variant || null);
        if (!variant && e.originalEvent) {
          variant = e.originalEvent.variant;
        }
        updateVatDisplay(section, variant);
      });
    });

    if (window.jQuery) {
      jQuery('[data-section-type="product"]').on('variantPriceChange', function (e, eventData) {
        var variant = (eventData && eventData.variant) ? eventData.variant : (e.variant || null);
        updateVatDisplay(this, variant);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();